export const ROLES = {
  ADMIN: "admin",
  LENDER: "lender",
  OWNER: "owner",
  GC: "gc",
  INSPECTOR: "inspector",
} as const;

export const CHAR_LIMIT = {
  NAME: 100,
  PHONE: 15,
  EMAIL: 254,
  ADDRESS: 200,
  DESCRIPTION: 1000,
  SHORT: 50,
};

export const CHAR_MIN = {
  CONTACT: 10,
};

export const NAME_REGEX = /^[a-zA-Z\s'.-]+$/;
export const EMAIL_REGEX =
  /^[a-zA-Z0-9!#$%&'*+\/=?^_{|}~-]+(\.[a-zA-Z0-9!#$%&'*+\/=?^_{|}~-]+)*@[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?(\.[a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?)*\.[a-zA-Z]{2,}$/;
export const PASSWORD_REGEX = /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/;

export const STATUS_LABEL: Record<string, string> = {
  approved: "Approved",
  rejected: "Rejected",
  admin_construction_report: "Admin Report",
  lender_action: "Lender Action",
  inspection_pending: "Inspection Pending",
  pending: "Pending",
  paid: "Paid",
  submitted: "Submitted",
  draft: "Draft",
  owner_signature_pending: "Owner Signature Pending",
  bank_rejected: "Owner Rejected",
  bank_change_request: "Owner Change Request",
};

export const STATUS_CLASS: Record<string, string> = {
  approved: "b-active",
  paid: "b-active",
  rejected: "b-denied",
  inspection_pending: "b-review",
  pending: "b-pre",
  submitted: "b-review",
  draft: "b-pre",
};

export const drawStatus = {
  DRAFT: "draft",
  SUBMITTED: "submitted",
  OWNER_SIGNATURE_PENDING: "owner_signature_pending",
  INSPECTION_PENDING: "inspection_pending",
  INSPECTION_COMPLETE: "inspection_complete",
  UNDER_REVIEW: "under_review",
  APPROVED: "approved",
  DENIED: "denied",
  CANCELLED: "cancelled",
  LENDER_ACTION: "lender_action",
  ADMIN_CONSTRUCTION_REPORT: "admin_construction_report",
};
